import React from 'react';
import { Paper as MuiPaper, withStyles, Typography } from '@material-ui/core';
import { styles } from './styles';
import { StyledComponentProps } from '@material-ui/core/styles';
import clsx from 'clsx';
import Collapse from '@material-ui/core/Collapse';
import { Up, Down } from '../../ui-components/Icons';

interface IProps extends StyledComponentProps {
    title?: string;
    children: any;
    fullHeight?: boolean;
    collapsed?: boolean;
    toggleCollapse?: () => any;
    containerStyle?: any;
    contentContainerStyle?: any;
    id?: string;
    ref_?: any;
    flex?: boolean;
}

const Paper = (props: IProps) => {
    const open = !props.collapsed;
    if (props.collapsed !== undefined && props.collapsed !== null)
        return (
            <MuiPaper ref={props.ref_}
                className={clsx(props.classes.paper, { [props.classes.fullHeight]: props.fullHeight })}
                style={props.containerStyle}
                id={props.id}>
                {props.title ?
                    <div className={props.classes.titleHeader} onClick={props.toggleCollapse}>
                        <Typography>{props.title}</Typography>
                        {open ? <Up style={{ fill: 'white', height: '10px' }} /> : <Down style={{ fill: 'white', height: '10px' }} />}
                    </div> : null}
                <Collapse in={open} timeout="auto">
                    <div style={props.contentContainerStyle}>
                        {props.children}
                    </div>
                </Collapse>
            </MuiPaper>)
    else
        return (
            <MuiPaper ref={props.ref_}
                className={clsx(props.classes.paper, { [props.classes.fullHeight]: props.fullHeight })}
                style={props.containerStyle}
                id={props.id}>
                {props.title ? <div className={props.classes.titleHeader}>
                    <Typography>{props.title}</Typography>
                </div> : null}
                <div style={props.contentContainerStyle} className={clsx(props.classes.contentContainer, { [props.classes.flex]: props.flex })}>
                    {props.children}
                </div>
            </MuiPaper>)

}

export default withStyles(styles)(Paper)